import { styled, Typography } from '@mui/material';

import { classes } from './NameBanner';

export const StyledText = styled(Typography)<{ color: string }>(
  ({ theme, color }) => ({
    width: 'min-content',
    whiteSpace: 'nowrap',
    [`&.${classes.element}`]: {
      color: theme.palette.greyBackgroundColor?.SURFACE,
      padding: theme.spacing(0.625, 1.5, 0.875, 1.5),
      borderRadius: theme.spacing(4),
      border: `1px solid ${theme.palette.invertedSubtleAction?.ENABLED}`,
      cursor: 'auto pointer',
    },
    [`&.${classes.section}`]: {
      cursor: 'auto !important',
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '0.08em',
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      ...theme.mixins?.[`${color}Gradient`],
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      color: 'transparent',
    },
  })
);
